import { connect } from 'react-redux';
import { withOffset as streamWithOffset } from '../../Stream';
import { getItems, hasMore, isFetching, getErrorMsg, } from '../../Stream/base/selectors';
import { RECOMMENDED_TORPEDO_STREAM_ID } from './constants';
import { initialize } from './actions';
var mapStateToProps = function (state) {
    return {
        deviations: getItems(state, RECOMMENDED_TORPEDO_STREAM_ID),
        hasMore: hasMore(state, RECOMMENDED_TORPEDO_STREAM_ID),
        isFetching: isFetching(state, RECOMMENDED_TORPEDO_STREAM_ID),
        errorMsg: getErrorMsg(state, RECOMMENDED_TORPEDO_STREAM_ID),
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        initialize: function () { return dispatch(initialize()); },
        fetchMore: function () {
            dispatch(streamWithOffset.actions.fetch(RECOMMENDED_TORPEDO_STREAM_ID));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=RecommendedTorpedo.container.js.map